module.exports = __webpack_public_path__ + "static/img/samajuri (27).0add3cc.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/samajuri/samajuri (27).jpg
// module id = kQZd
// module chunks = 0